import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../app/store";
import { Paths } from "../router/Paths";

export default function useAdminOnly() {
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.user);

  useEffect(() => {
    if (user?.role !== "Admin") {
      window.location.href = Paths.cars;
      // navigate(Paths.cars);
    }
  }, [user]);

  return undefined;
}
